import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { useAuth } from '../../context/AuthContext';
import logoImg from '../../assets/logo-work-transparent.png';
import { getUserProfileByUid } from '../../services/userProfileService';
import { signOutUser } from '../../services/authService';
import { sendWebReadyOnce } from '../../bridge/webviewBridge';

const SplashPage = () => {
  const navigate = useNavigate();
  const { currentUser, loading, refreshUser } = useAuth();
  const resolving = useRef(false);

  useEffect(() => {
    sendWebReadyOnce();
  }, []);

  useEffect(() => {
    if (loading || resolving.current) return;

    if (!currentUser) {
      navigate('/login', { replace: true });
      return;
    }

    resolving.current = true;

    (async () => {
      try {
        const profile = await getUserProfileByUid(currentUser.uid);
        await refreshUser();

        // 0) user doc 자체가 없음 (삭제된 계정) → 로그아웃 후 로그인 화면
        if (!profile) {
          await signOutUser();
          navigate('/login', { replace: true });
          return;
        }

        // 1) 전화번호 미인증 → 전화인증부터
        if (!profile.phoneE164) {
          navigate('/link-phone', { replace: true });
          return;
        }

        // 2) 전화번호는 있지만 프로필 정보 미완성 → 프로필 저장
        if (!profile.name || !profile.companyName) {
          navigate('/complete-profile', { replace: true });
          return;
        }

        // 3) 프로필 완성됐지만 승인 대기 → 대기 화면
        if (profile.status !== 'approved') {
          navigate('/pending', { replace: true });
          return;
        }

        // 4) 모두 통과 → 메인
        navigate('/home', { replace: true });
      } catch (err) {
        console.error('SplashPage 분기 실패:', err);
        navigate('/login', { replace: true });
      } finally {
        resolving.current = false;
      }
    })();
  }, [loading, currentUser, navigate, refreshUser]);

  return (
    <Container>
      <LogoImage src={logoImg} alt="WORK OUR PARTNERS" />
      <Spinner />
    </Container>
  );
};

export default SplashPage;

const Container = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #fff;
  gap: 32px;
`;

const LogoImage = styled.img`
  width: 200px;
  height: auto;
  object-fit: contain;
`;

const Spinner = styled.div`
  width: 28px;
  height: 28px;
  border: 3px solid rgba(0, 0, 0, 0.08);
  border-top-color: #C5A55A;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  @keyframes spin { to { transform: rotate(360deg); } }
`;
